import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

function list(params) {
  return request({
    url: ENDPOINT.ORGANIZATION_SETTINGS,
    method: "get",
    params,
  });
}

function show(id, params) {
  return request({
    url: `${ENDPOINT.ORGANIZATION_SETTINGS}/${id}`,
    method: "get",
    params,
  });
}

function update(id, data) {
  return request({
    url: `${ENDPOINT.ORGANIZATION_SETTINGS}/${id}`,
    method: "patch",
    data,
  });
}

function setCurrentOrg(data) {
  localStorage.setItem("current_org", JSON.stringify(data));
}

function getCurrentOrg() {
  try {
    return JSON.parse(localStorage.getItem("current_org")) || null;
  } catch (_) {
    return null;
  }
}

export default {
  list,
  show,
  update,
  setCurrentOrg,
  getCurrentOrg
};
